import React from 'react';
import { Avatar } from '../core/Avatar.jsx';
import { Button } from '../core/Button.jsx';
import { Badge } from '../core/Badge.jsx';

/** Podcast homepage hero: cover, kicker, display title, tagline, hosts, actions, stats. */
export function ShowHeader({
  title = '边角聊',
  kicker = 'PODCAST · LEFTOVER TALK',
  tagline,
  cover,
  hosts = [],
  stats = [],
  isMember = false,
  onPlayLatest,
  onMembership,
  className = '',
}) {
  return (
    <div className={`bjl-showheader ${className}`}>
      {cover ? <span className="bjl-showheader__cover"><img src={cover} alt={`${title} 封面`} /></span> : null}
      <div style={{ minWidth: 0 }}>
        <span className="bjl-showheader__kicker">{kicker}</span>
        <h1 className="bjl-showheader__title">
          {title}
          {isMember ? <Badge variant="member" icon="verified">年度会员</Badge> : null}
        </h1>
        {tagline ? <p className="bjl-showheader__tagline">{tagline}</p> : null}
        {hosts.length ? (
          <div className="bjl-showheader__hosts">
            {hosts.map((h) => <Avatar key={h.name} name={h.name} src={h.src} size={28} />)}
            <span>{hosts.map((h) => h.name).join(' × ')} 主持</span>
          </div>
        ) : null}
        <div className="bjl-showheader__actions">
          <Button icon="play_arrow" size="lg" onClick={onPlayLatest}>播放最新一集</Button>
          {!isMember ? (
            <Button variant="secondary" size="lg" onClick={onMembership}>成为会员</Button>
          ) : null}
        </div>
        {stats.length ? (
          <div className="bjl-showheader__stats">
            {stats.map((s) => (
              <span key={s.label}><b>{s.value}</b> {s.label}</span>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
